import { Link } from 'react-router-dom';

import { toNpub } from '@/lib/stashstr';
import { cn } from '@/lib/utils';

/**
 * Clickable author name (bright blue like stasher.news) linking to the
 * user's Nostr profile/bio at /<npub>.
 * Malformed pubkeys render a grey non-link fallback (blue implies clickable).
 */
export function AuthorLink({
  pubkey,
  name,
  className,
}: {
  pubkey: string;
  name?: string;
  className?: string;
}) {
  const label = name && name.length > 0 ? name : pubkey.slice(0, 8);

  const npub = toNpub(pubkey);
  if (!npub) {
    return (
      <span className={cn('font-medium text-gray-500 dark:text-gray-400', className)}>
        @{label}
      </span>
    );
  }

  return (
    <Link
      to={`/${npub}`}
      className={cn(
        'font-medium text-[#007bff] dark:text-[#6ea8fe] hover:underline',
        className,
      )}
    >
      @{label}
    </Link>
  );
}
